import './utils/storageMirror';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/style.css';
import * as serviceWorker from './serviceWorker';
import { silenceResizeObserverError } from './utils/errorHandler';
import { initGoogleTagManager } from './utils/googleTagManager';
import 'react-notifications/lib/notifications.css';
import 'flatpickr/dist/themes/light.css';
import 'react-image-crop/dist/ReactCrop.css'

silenceResizeObserverError();
initGoogleTagManager();

const rootContainer = document.getElementById('root');
const root = createRoot(rootContainer);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

serviceWorker.unregister();
